// external imports
import { useEffect, useContext, useState, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { Tooltip } from 'react-tooltip';
import { useLocation } from 'react-router-dom';

// internal imports
import exportConfig from '../config';
import {
	CurrentlyInQCAllUsers,
	CurrentlyQCingUser,
	DataLoaded,
	QCActivityGraph,
	DailyQCComplete,
	SiteChanges
} from '../components/dashboard';

// hooks & services
import { pipelineContext } from '../contexts/pipelineContext';
import { endpointContext } from '../contexts/endpointContext';
import useGainsQCApi from '../services/useGainsQCApi';
import SHIcon from '../images/SHIcon.png';
import NavigateIcon from '../images/gains-logo-dark.svg';
import favicon from '../images/favicon-2.png';

export default function Dashboard(props) {
	const endpointContextDashboard = useContext(endpointContext);
	const pipelineContextDashboard = useContext(pipelineContext);

	const [removeCapsList, setRemoveCapsList] = useState();
	const [dashboardInfoAll, setDashboardInfoAll] = useState({
		smelters: {
			capsInQC: [
				{
					user: 'madiha.abbas',
					count: 20
				},
				{
					user: 'lucy.colley',
					count: 2
				}
			],
			lastQC: {
				count: 23,
				user: 'george.begkas',
				date: '13:24:12 26/11/24',
				type: 'daily'
			},
			userQC: {
				user: 'lucy.colley',
				toQC: 34,
				toUpload: 3
			},
			dailyQC: {
				preQCDate: '06:04 27/11/2024',
				QCDate: '11:18 27/11/2024',
				postQCDate: null,
				uploadDate: null,
				dataCheckDate: null
			}
		},
		stockpiles: {
			capsInQC: [
				{
					user: 'joshua.large',
					count: 14
				}
			],
			lastQC: {
				count: 23,
				user: 'joshua.large',
				date: '17:45:23 14/10/24',
				type: 'Historic'
			},
			userQC: {
				user: 'lucy.colley',
				toQC: 0,
				toUpload: 0
			},
			dailyQC: {
				preQCDate: null,
				QCDate: null,
				postQCDate: null,
				uploadDate: null,
				dataCheckDate: null
			}
		},
		airfields: {
			capsInQC: [],
			lastQC: {
				count: null,
				user: null,
				date: null,
				type: null
			},
			userQC: {
				user: 'lucy.colley',
				toQC: 0,
				toUpload: 0
			},
			dailyQC: {
				preQCDate: null,
				QCDate: null,
				postQCDate: null,
				uploadDate: null,
				dataCheckDate: null
			}
		}
	});
	const [dashboardInfo, setDashboardInfo] = useState(null);
	const [dashboardQCType, setDashboardQCType] = useState('smelters');

	const [users, setUsers] = useState();

	const fetchCaptureCommentsForSite = useGainsQCApi();

	useEffect(() => {
		pipelineContextDashboard.setNavigateHome(false);
		setDashboardInfo(dashboardInfoAll['smelters']);
		document.title = 'GAINS QC | Home';
	}, []);

	useEffect(() => {
		pipelineContextDashboard.resetState();
		endpointContextDashboard.refresh();
		fetchingCaptureCommentsForSite();
	}, []);

	const fetchingCaptureCommentsForSite = async () => {
		await fetchCaptureCommentsForSite.makeRequest(
			`/smelters/comments/steel?subject_id=1234`,
			'GET',
			null,
			'',
			0
		);
	};

	console.log(endpointContextDashboard);

	const sumNumbers = (obj) => {
		let sum = 0;
		for (let key in obj) {
			if (typeof obj[key] === 'number') {
				sum += obj[key];
			} else if (typeof obj[key] === 'object' && obj[key] !== null) {
				sum += sumNumbers(obj[key]);
			}
		}
		return sum;
	};

	return (
		<>
			{props.authProps.isAuthenticated ? (
				<>
					<div className="px-0 col" id="secondColumn">
						<div className="contentContainer">
							<div style={{ marginTop: '58px' }}>
								<hr className="container-hr"></hr>

								<div className="row">
									<div className="col col-6">
										<h3>
											Welcome to QC{' '}
											<strong>
												{props.authProps.userAttributes.givenName}
											</strong>
										</h3>{' '}
									</div>

									<div className="col col-6 d-flex justify-content-end">
										{' '}
										<div
											className="d-flex justify-content-center align-items-top pe-4 pt-1"
											style={{ width: '18px', height: '18px' }}
										>
											<div style={{ position: 'absolute' }}>
												{endpointContextDashboard.loading ? (
													<ClipLoader size={18} />
												) : (
													<i
														data-tooltip-id="dashboard-stats-refresh-TT"
														onClick={(e) => endpointContextDashboard.refresh()}
														className="fa-solid fa-rotate-right"
													></i>
												)}
											</div>
										</div>
									</div>

									<Tooltip id="dashboard-stats-refresh-TT">
										Refresh dashboard stats
									</Tooltip>
								</div>

								<div className="row">
									<div className="col col-md-6">
										<h6>
											Welcome to the Earth-i QC Tool, where you can find
											information about all captures in the database and perform
											a Quality Control inspection for a given set of
											captures.{' '}
										</h6>
									</div>

									<div className="col col-md-6"></div>
								</div>

								<div className="row">
									<h4 className="mt-4 mb-2">
										{
											<i
												className={
													exportConfig.siteTypesIds.filter(
														(type) => type.name === dashboardQCType
													)[0].icon
												}
											></i>
										}{' '}
										{dashboardQCType.charAt(0).toUpperCase() +
											dashboardQCType.slice(1)}
									</h4>

									<div className="col-8">
										<div className="row my-2" style={{ height: 'auto' }}>
											<div className="row my-4" style={{ height: 'auto' }}>
												<div className="col-6">
													<CurrentlyQCingUser
														user={props.authProps.userAttributes}
														loading={endpointContextDashboard.loading}
														error={endpointContextDashboard.error}
														data={
															endpointContextDashboard.dbData?.capsInUsersQueues
																? endpointContextDashboard.dbData
																		.capsInUsersQueues
																: null
														}
													/>
												</div>

												<div className="col-6">
													<DailyQCComplete dashboardInfo={dashboardInfo} />
												</div>
											</div>
										</div>

										<div className="row my-4" style={{ height: 'auto' }}>
											<div className="col-8"></div>
										</div>

										<div className="row my-4" style={{ height: 'auto' }}>
											<div className="col-12">
												{' '}
												<QCActivityGraph />
											</div>
										</div>
									</div>

									<div className="col-4">
										<div className="row my-2" style={{ height: 'auto' }}>
											<div className="row my-4" style={{ height: 'auto' }}>
												<div className="col-12">
													<DataLoaded
														loading={endpointContextDashboard.loading}
														error={endpointContextDashboard.error}
														data={endpointContextDashboard.dbData}
														timeNow={endpointContextDashboard.dbData.lastUpdate}
														userCount={users}
													/>
												</div>
											</div>

											<div className="row my-4" style={{ height: 'auto' }}>
												<div className="col-12">
													<CurrentlyInQCAllUsers
														loading={endpointContextDashboard.loading}
														error={endpointContextDashboard.error}
														data={
															endpointContextDashboard.dbData?.capsInUsersQueues
																? endpointContextDashboard.dbData
																		.capsInUsersQueues
																: null
														}
													/>
												</div>
											</div>

											<div className="row my-4" style={{ height: 'auto' }}>
												<div className="col-12"></div>
											</div>

											<div className="row my-4" style={{ height: 'auto' }}>
												<div className="col-12">
													<div class="dashboard-card">
														<div
															class="dashboard-card-header"
															data-tooltip-id="dashboard-system-status"
														>
															<div className="row">
																<div className="col">
																	<i className="fa-solid fa-link me-2"></i>{' '}
																	Useful links
																</div>
																<div className="col d-flex justify-content-end"></div>
															</div>
														</div>
														<div class="dashboard-card-body">
															<div className="table my-0 py-0">
																<table
																	className="table dashboard-stats-table my-0"
																	style={{ width: '80%' }}
																>
																	<tr>
																		<td>
																			<img
																				src={NavigateIcon}
																				alt="Icon description"
																				width="80"
																				height="30"
																			/>
																		</td>
																		<td>
																			<a
																				href="https://navigate-dev.gains.earthi.world/signUp"
																				target="_blank"
																			>
																				Gains Navigate (dev)
																			</a>
																		</td>
																	</tr>

																	<tr>
																		<td>
																			<img
																				src={NavigateIcon}
																				alt="Icon description"
																				width="80"
																				height="30"
																			/>
																		</td>
																		<td>
																			<a
																				href="https://navigate.gains.earthi.world/"
																				target="_blank"
																			>
																				Gains Navigate (prod)
																			</a>
																		</td>
																	</tr>

																	<tr>
																		<td>
																			<img
																				src={NavigateIcon}
																				alt="Icon description"
																				width="80"
																				height="30"
																			/>
																		</td>
																		<td>
																			<a
																				href="https://earth-i.atlassian.net/wiki/spaces/~62fb93258cdffa3a9a29d7b7/pages/3016720385/Gains+QC+App+-+User+Guide"
																				target="_blank"
																			>
																				QC User Guide
																			</a>
																		</td>
																	</tr>

																	<tr>
																		<td>
																			<img
																				src={favicon}
																				alt="Icon description"
																				width="50"
																				height="50"
																			/>
																		</td>
																		<td>
																			<a
																				href="https://admin.gains.earthi.world/"
																				target="_blank"
																			>
																				Gains Admin Tool
																			</a>
																		</td>
																	</tr>

																	<tr>
																		<td>
																			<img
																				src={SHIcon}
																				alt="Icon description"
																				width="40"
																				height="40"
																			/>
																		</td>
																		<td>
																			<a
																				href="https://apps.sentinel-hub.com/eo-browser/"
																				target="_blank"
																			>
																				Sentinel Hub EO Browser
																			</a>
																		</td>
																	</tr>
																</table>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="row my-4" style={{ height: 'auto' }}>
												<div className="col-12">
													<SiteChanges />
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</>
			) : (
				<Navigate to="/login" />
			)}
		</>
	);
}
